export var ApiRateLimitConfigEnum;
(function (ApiRateLimitConfigEnum) {
    ApiRateLimitConfigEnum["ALGORITHM"] = "algorithm";
    ApiRateLimitConfigEnum["COST"] = "cost";
    ApiRateLimitConfigEnum["MAXIMUM"] = "maximum";
})(ApiRateLimitConfigEnum || (ApiRateLimitConfigEnum = {}));
